import React from "react";
import { getPageDisplayName } from "./pageNameMapper";

const PageAnalyticsTable = ({ data, totalVisits }) => {
  return (
    <div className="page-analytics-section">
      <div className="page-analytics-card">
        <h3 className="page-analytics-title">Page Analytics</h3>
        <div className="page-analytics-table">
          <div className="page-analytics-header">
            <div className="table-col-page">Page/Module</div>
            <div className="table-col-views">Total Views</div>
            <div className="table-col-engagement">Engagement Rate</div>
          </div>
          <div className="page-analytics-body">
            {data.map((page, index) => {
              const engagementRate = totalVisits > 0 
                ? ((page.visits / totalVisits) * 100).toFixed(1) 
                : 0;
              return (
                <div key={index} className="page-analytics-row">
                  <div className="table-col-page">{getPageDisplayName(page.page)}</div>
                  <div className="table-col-views">{page.visits}</div>
                  <div className="table-col-engagement">
                    <div className="engagement-bar-container">
                      <div 
                        className="engagement-bar" 
                        style={{ width: `${engagementRate}%` }}
                      ></div>
                    </div>
                    <span className="engagement-text">{engagementRate}%</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAnalyticsTable;
